import React, { useState } from "react";
import UsersWidget from "../usersWidget/usersWidget";
import { useSelector } from "react-redux";
import "./plantHeader.scss";
import { withNavigation } from "../withNavigate";
import Weather from "../weatherHeader/weather";
import { getCurrentProject } from "../../utils/projectUtils";
import { useNavigate } from "react-router";

const PlantHeader = (props) => {
  const navigate = useNavigate();
  const [project, setProject] = useState(props.project || getCurrentProject());

  const getAddress = () => {
    if (!project) return "";

    let str = project.streetAddress || "";
    if (str === ".") str = "";

    if (project.state && str.length) str += ", ";
    str += project.state || "";

    return str;
  };

  return (
    <div className="plant-header">
      <UsersWidget />

      {props.title ? (
        <div className="first-text">{props.title}</div>
      ) : project ? (
        <div className="project-title">
          <div className="plant-name">
            {project.projectName} / {project.totalPower}
            MW
          </div>
          <div className="address">{getAddress()}</div>
        </div>
      ) : null}

      {!props.title && project ? (
        <Weather
          timezoneOffset={
            project.timezone.rawOffset + project.timezone.dstOffset
          }
        />
      ) : null}
      {props.secondaryText ? (
        <div>
          <div>
            <span className="slash">/</span>
            <a
              href={props.secondaryLink || "/dashboard?project=" + project?._id}
              className="second-text"
            >
              {props.secondaryText}
            </a>
          </div>
          {props.thirdText ? (
            <div>
              <span className="slash">/</span>
              <a href={props.thirdLink || "#"} className="second-text">
                {props.thirdText}
              </a>
            </div>
          ) : null}
        </div>
      ) : project ? (
        <div className="right">
          {props.projectData ? (
            <div style={{ display: "inline" }}>
              <div className="item orange">
                <div className="name">Cycles completed</div>
                <div className="value ">{project.cyclesCompleted}</div>
              </div>

              <div className="item orange">
                <div className="name">Total area cleaned</div>
                <div className="value ">{project.areaCleaned}m²</div>
              </div>
            </div>
          ) : null}

          {project?.arrayType !== "fixed" ? (
            <div className="item default">
              <div className="name">Number of rows</div>
              <div className="value">{project.numberOfRows}</div>
            </div>
          ) : null}

          {/*<div className="item default">*/}
          {/*    <div className="name">Number of robots</div>*/}
          {/*    <div*/}
          {/*        className="value">{project.numberOfTypeOneRobots + project.numberOfTypeTwoRobots}</div>*/}
          {/*</div>*/}

          {project.numberOfVehicles ? (
            <div className="item default">
              <div className="name">Number of vehicles</div>
              <div className="value">{project.numberOfVehicles}</div>
            </div>
          ) : null}
        </div>
      ) : null}

      {props.children}
    </div>
  );
};

export default withNavigation(PlantHeader);
